<template>
  <div class="footer-wrapper">
    <p><a href="https://beian.miit.gov.cn/" target="_blank"
      >京ICP备10012705号-17</a></p>
    <p>版权所有 ©{{ currentYear }} 58同城基础平台研发中心</p>
  </div>
</template>

<script>
export default {
  name: "FooterPage",
  props: {},
  data() {
    return {};
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-wrapper {
  padding: 60px 20px;
  text-align: center;
  color:#666;
  font-size: 14px;
  p{
    font-size: 14px;
    line-height: 30px;
  }
  a {
    color: #666;
    cursor: pointer;
    &:hover{
      color: #000;
    }
  }
}
</style>
